module.exports = __webpack_public_path__ + "static/media/slide3.006fe42b.jpg";